/* @generated */
import React__default from "react";
import { useTheme } from "@dropbox/dig-foundations";
function useThemedStyle({ over }) {
  const { theme, mode } = useTheme();
  const style = React__default.useMemo(
    () => ({
      /**
       * Theme does not yet have over solved with tokens, so we need a holdover to apply a
       * token value for dark mode since vis2020 does not have support for dark mode
       *
       * TODO: Convert this into a better `over` token
       */
      "--dig-color__fileicon__container": over === "subtle" && theme === "vis2020" && mode === "dark" ? "#ffffff" : void 0
      // Tell it to be CSSProperties because dynamic CSS Vars aren't in the definition
    }),
    [theme, mode, over]
  );
  return style;
}
export {
  useThemedStyle
};
